import { ProductTileFeature } from "@omni/types/api/product/bff/shared/productTileFeature.model";
import { useMemo } from "react";

import { displayFeature } from "@/utils/features/display";

import { CellComponent } from "./cell.component";

type CellProps = {
    productFeatures: Array<ProductTileFeature>;
    featureName: string;
    sectionName: string;
};

const Cell = ({ productFeatures, featureName, sectionName }: CellProps) => {
    const featureValues: Record<
        string,
        Record<string, string>
    > = useMemo(() => {
        return productFeatures.reduce(
            (acc: Record<string, Record<string, string>>, feature) => ({
                ...acc,
                [feature.kind!.name]: {
                    ...(acc[feature.kind!.name] || {}),
                    [feature.name]: displayFeature({
                        formattedValues: feature.featureValues.map(
                            (fv) => fv.formattedValue || ""
                        ),
                        unitName: feature.unit?.name
                    })
                }
            }),
            {}
        );
    }, [productFeatures]);

    return (
        <CellComponent
            featureValues={featureValues}
            featureName={featureName}
            sectionName={sectionName}
        />
    );
};

export { Cell };
